const rawConfig = {
  masters: [
    { name: "Bank", value: "bank" },
    { name: "Broker", value: "broker" },
    { name: "Financial Year", value: "financial-year" },
    { name: "Role", value: "role" },
    { name: "Industry", value: "industry" },
    { name: "Pincode", value: "pincode" },
    { name: "Segment", value: "segment" },
    { name: "Scrip", value: "script" },
    { name: "Security Type", value: "security" },
    { name: "Depository", value: "depository" },
    { name: "Corporate Action", value: "corporate-action" },
    { name: "Coupon", value: "coupon" },
    { name: "Pricing", value: "pricing" },
    { name: "Ledger", value: "ledger" },
  ],
  import: [
    { name: "Opening Stock", value: "opening-stock" },
    { name: "Contract Note", value: "contract-list" },
    { name: "Bank Statement", value: "bank-statement" },
  ],
  corporateAction: [
    { name: "Eligible Holding", value: "eligible-holding" },
    { name: "Corporate Action Ledger", value: "ca-ledger" },
    // { name: "Bonus", value: "bonus" },
    // { name: "Split", value: "split" },

    // {
    //   name: "Merger | Demerger | Amalgamation",
    //   value: "merger-demerger-amalgamation",
    // },
    // { name: "Rights Issue", value: "rights-issue" },
    // { name: "Buyback", value: "buyback" },
    // { name: "Financial Year", value: "financial-year" },
  ],
  reports: [
    { name: "Capital Gains", value: "capital-gains" },
    { name: "Dividend Received", value: "dividend" },
    { name: "Expense Incurred", value: "expense-incurred" },
    { name: "Financial Ledger", value: "financial-ledger" },
    { name: "F&O P&L Report", value: "fo-pl-report" },
    { name: "Open F&O Positions", value: "open-fo-positions" },
    { name: "Current Holding", value: "current-holding" },
  ],
  resources: [
    { name: "License Order", value: "license-order" },
    { name: "Service Order", value: "service-order" },
    { name: "Assign Coupon", value: "assign-coupon" },
    { name: "My Subscribers", value: "my-subscribers" },
    { name: "Payment History", value: "payment-history" },
    { name: "Assign Member Role", value: "assign-member-role" },
    { name: "Import Subscribers", value: "import-subscriber" },
    { name: "Manage Subscriber", value: "manage-subscriber" },
  ],
  configure: [
    { name: "Member", value: "member" },
    { name: "Subscriber", value: "subscriber" },
    { name: "Consultant", value: "consultant" },
    { name: "Accountant", value: "accountant" },
    { name: "Back Office", value: "back-office" },
  ],
  api: [{ name: "Api", value: "value" }],
  profile: [
    { name: "Profile", value: "profile" },
    { name: "Change Password", value: "change-password" },
    { name: "Dashboard", value: "dashboard" },
    { name: "Select Subscribers", value: "" },
    { name: "Log Out", value: "logout" },
  ],
};

export default rawConfig;
